/* global modForm */
import { parseHTMLFromString, trackFormSubmissionFlow } from '../../../helpers';
/**
 * * Initializes and appends the loading overlay markup to the DOM.
 * Guards against duplicate initialization using the `isLoaderLoaded` flag.
 *
 * **Conditions required for initialization**:
 * - `window.Loader` global must be available
 * - Either `modForm.opts.showLoadingOverlay` or `modForm.opts.showRedirectOverlay` must be enabled
 * - Loader must not have already been initialized (`modForm.opts.isLoaderLoaded` is falsy)
 *
 * **Behavior**:
 * - Tracks the submission flow via `trackFormSubmissionFlow({ initiatingLoader: true })`
 * - Retrieves loader HTML from `window.Loader.getLoaderHTML()`, passing `!isBranded && !modForm.showinterstitialLoader`
 *   so unbranded is the default when `isBranded` is not set; interstitial markup is used when `modForm.showinterstitialLoader` is true
 * - Appends the parsed markup to `modForm.opts.appendOverlayToElem`
 * - Sets `modForm.opts.isLoaderLoaded = true` to prevent re-initialization
 */
export function initFormSubmitLoader() {
	if (window.Loader && (modForm.opts.showLoadingOverlay || modForm.opts.showRedirectOverlay) && !modForm.opts.isLoaderLoaded) {
		trackFormSubmissionFlow({ initiatingLoader: true });
		const isBranded = modForm.opts.isBranded ?? false;
		const loaderMarkUp = parseHTMLFromString(window.Loader.getLoaderHTML(!isBranded && !modForm.showinterstitialLoader));
		modForm.opts.appendOverlayToElem.append(loaderMarkUp);
		modForm.opts.isLoaderLoaded = true;
	}
}
